module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"Items":"Pedido","PaymentMethod":"Tipo de Cobrança","Customer":"Dados do Cliente","PaymentData":"Pagamento","ReviewOrder":"Resumo","SubscriptionDetails":"Dados da Recorrência"},"en-US":{"Items":"Order","PaymentMethod":"Payment Method","Customer":"Customer Information","PaymentData":"Payment","ReviewOrder":"Review","SubscriptionDetails":"Subscription Details"}}')
  delete Component.options._Ctor
}
